import { apiServiceFactory } from '@scalar-org/service-api'

import { config } from '@/config'

import { getAuthData, refreshToken } from './auth'
import { generateAccessByPersonalToken } from '@/domains/auth/login/helpers/personal-token-generate-access'

export const apiService = async (): Promise<
  ReturnType<typeof apiServiceFactory>
> => {
  const auth = await getAuthData()
  auth.addEventListener((state) => Object.assign(auth, state))

  return apiServiceFactory(
    config.services.api,
    () => auth.accessToken,
    async (teamUid?: string) => {
      if ('refreshToken' in auth) {
        await refreshToken(auth.refreshToken, teamUid)
        return
      }
      await generateAccessByPersonalToken({
        personalToken: auth.personalToken,
      })
    },
  )
}
